module.exports = __webpack_public_path__ + "static/img/areaA-32.ad89684.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA-32.png
// module id = 976
// module chunks = 1